import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'dispose-readonly-value',
  props: {
    value: {},
    multiline: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const display = computed(() => {
  const v = props.value
  if (v == null || v === '') return '--'
  return String(v)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["dispose-readonly-value", { 'is-multiline': _ctx.multiline }])
  }, _toDisplayString(display.value), 3))
}
}

})